export const LoadingAnimation = (
  <svg
    width="61"
    height="61"
    viewBox="0 0 412 412"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ color: "var(--YW_SignIn_Modal_LoadingRing_Color)" }}
  >
    <circle
      cx="206"
      cy="206"
      r="195"
      stroke="url(#paint0_linear)"
      strokeWidth="22"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        from="0 206 206"
        to="360 206 206"
        dur="1s"
        repeatCount="indefinite"
      />
    </circle>
    <defs>
      <linearGradient id="paint0_linear" x1="206" y1="0" x2="227" y2="412" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="currentColor">
          <animate
            attributeName="stop-color"
            values="currentColor;currentColor;currentColor;currentColor;currentColor"
            dur="1s"
            repeatCount="indefinite"
          />
        </stop>
        <stop offset="100%" stopColor="white" stopOpacity="0.33">
          <animate
            attributeName="stop-color"
            values="white;white;white;white;white"
            dur="1s"
            repeatCount="indefinite"
          />
        </stop>
      </linearGradient>
    </defs>
  </svg>
);
